import React from 'react';
import { Button, Input, Col, Row, Container, FormGroup, Label, Form } from 'reactstrap';
import DeckGL from '@deck.gl/react';
import { ScatterplotLayer, IconLayer, TextLayer } from '@deck.gl/layers';
import { MapView } from '@deck.gl/core';
import { StaticMap } from 'react-map-gl';
import numeral from 'numeral';
import api from '../../api';
import Constant from '../../constants';
import GoogleMap from '../../components/GoogleMap';
import './index.css';

class BrandItem extends React.Component {
    constructor(props) {
        super(props);
        const { brand, currentUser } = this.props;
        this.state = {
            isShowLocationList: false,
            locationsTimeSeriesMetrics: null,
            isCurrentUserBrand: brand.brand_id === currentUser.user_brand.brand_id,
        };
    }
    componentDidMount() {
        const { isCurrentUserBrand } = this.state;
        if (isCurrentUserBrand) {
            this.getLocationsMetrics();
        }
    }
    showLocationList() {
        const { isShowLocationList } = this.state;
        this.setState({
            isShowLocationList: !isShowLocationList,
        });
    }
    getLocationsMetrics() {
        const { isCurrentUserBrand } = this.state;
        const { nearbyLocations, currentUser } = this.props;
        const userBrandLocationIds = nearbyLocations.filter(nearbyLocation => nearbyLocation.brand_id === currentUser.user_brand.brand_id).map(nearbyLocation => nearbyLocation.id);
        // Only load metrics for current user brand
        if (isCurrentUserBrand) {
            api.fetchAPI({
                method: 'get',
                uri: `location/metrics/time_series/avg?location_ids=${userBrandLocationIds.join(',')}`,
                success: (response) => {
                    if (response.location_time_series_metrics) {
                        this.setState({
                            locationsTimeSeriesMetrics: response.location_time_series_metrics,
                        });
                    }
                },
                error: (error) => {
                console.error(error);
                }
            });
        }
    }
    render() {
        const { brand, currentUser, nearbyLocations } = this.props;
        const { isCurrentUserBrand, isShowLocationList, locationsTimeSeriesMetrics } = this.state;
        return (
            <div>
                <p
                    onClick={() => this.showLocationList(true)}>
                    <span>
                        <span style={brandItemStyles.brandNumberOfPoints}>{brand.number_of_points}</span>
                        <span style={brandItemStyles.brandName}>{brand.brand_name || 'Không có brand'}</span>
                    </span>
                </p>
                {isShowLocationList &&
                    <div className="map_screen__locations">
                        <p onClick={() => this.showLocationList(false)} className="map_screen__locations__close-button">x</p>
                        {nearbyLocations.filter(nearbyLocation => nearbyLocation.brand_id === brand.brand_id).map(nearbyLocation =>
                            <LocationItem
                                key={nearbyLocation.id}
                                item={nearbyLocation}
                                currentUser={currentUser}
                                timeSeriesMetrics={
                                    locationsTimeSeriesMetrics ?
                                        locationsTimeSeriesMetrics.find(locationMetrics => locationMetrics.location_id === nearbyLocation.id)
                                        :
                                        null
                                }
                            />
                        )}
                    </div>
                }
            </div>
        );
    }
}

const brandItemStyles = {
    brandName: {
        color: 'var(--color-accent-dark)',
    },
    brandNumberOfPoints: {
        marginRight: 12,
        width: 24,
        height: 24,
        borderRadius: '50%',
        backgroundColor: 'var(--color-line)',
        color: 'var(--color-black)',
        display: 'inline-block',
        textAlign: 'center',
        fontSize: 14,
    },
}

const LocationItem = ({ item, currentUser, timeSeriesMetrics }) => {
    return (
        <div className="map_screen__location-item">
            <div>
                <a
                    className="map_screen__location-item__link"
                    target="_blank"
                    href={currentUser.user_brand.brand_id === item.brand_id ? `/sitev2/${item.id}` : `/market_information/${item.id}`} rel="noreferrer"
                >
                    <span className="map_screen__location-item__title">{item.name}</span>
                    <span className="map_screen__location-item__distance">{numeral(item.distance_in_km * 1000).format('0,0')}m</span>
                </a>
            </div>
            <div className="map_screen__location-item__info">
                <LocationItemMetrics title="Giá thuê" value={item.lease_rate} />
                <LocationItemMetrics title="Diện tích" value={item.area} unit="m2" />
                {timeSeriesMetrics && <LocationItemMetrics title="Gross Sales" value={timeSeriesMetrics.average_gross_sales} />}
                {timeSeriesMetrics && <LocationItemMetrics title="TC" value={timeSeriesMetrics.average_tickets} />}
            </div>
        </div>
    );
};

const LocationItemMetrics = ({ title, value, unit }) => (
    <div className="map_screen__location-item__info_detail">
        <span className="map_screen__location-item__info_detail-title">{title}</span><br />
        <span className="map_screen__location-item__info_detail-value">{numeral(value).format('0,0')}</span>
        {unit && <span className="map_screen__location-item__info_detail-unit">{unit}</span>}
    </div>  
);

class MapComponent extends React.Component {
    constructor(props) {
        super(props);
        const { latitude, longitude, scanningRadius } = this.props;
        this.state = {
            searchKeyword: '',
            searchResults: [],
            searchResultCount: 0,
            isSearching: false,
            isLoading: false,
            currentUser: null,
            currentLocation: {
                latitude: latitude ? latitude : 10.776530,
                longitude: longitude ? longitude : 106.700981,
            },
            viewState: {
                latitude: latitude ? latitude : 10.776530,
                longitude: longitude ? longitude : 106.700981,
                zoom: 15,
                pitch: 0,
                bearing: 0
            },
            scanningRadius: scanningRadius ? scanningRadius : 0.3,
            city: {
                id: 29,
            },
            showLocations: true,
            showDistricts: true,
            locationTypes: [],
            filterLocationTypeIds: [],
            planningPoints: [],
            planningPoint: {},
            showMapControls: false,
            selectedBrandId: null,
            searchBrandName: '',
            showOverlayMenu: false,
            mapMode: 'mapbox',
            mapTheme: 'streets-v11',
        }
        this.initialViewState = {
            latitude: latitude ? latitude : 10.776530,
            longitude: longitude ? longitude : 106.700981,
            zoom: 15,
            pitch: 0,
            bearing: 0
        }
    }
    UNSAFE_componentWillMount() {
        this.getCurrentUser();
        if (!this.props.latitude || !this.props.longitude) {
            // Get current location
            this.getCurrentPosition();
        } else {
            // If current location was set by props, get nearby location
            this.getNearbyLocations()
        }
        this.getDistrictByCity();
        this.getLocationTypes();
        this.getPlanningLocations();
    }
    componentDidMount = () => {
        document.title = "LISA Home";
        // this.getNearbyLocations();
    }
    getCurrentPosition() {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                this.setState({ 
                    currentLocation: {
                        latitude: position.coords.latitude, 
                        longitude: position.coords.longitude
                    },
                    viewState: {
                        ...this.state.viewState,
                        latitude: position.coords.latitude, 
                        longitude: position.coords.longitude
                    }
                }, this.getNearbyLocations)
            },
            err => {
                alert('Error code ' + err.code + ': ' + err.message)
                this.setState({
                    currentLocation: this.initialViewState
                }, this.getNearbyLocations)
            }
        );
    }
    getCurrentUser() {
        api.fetchAPI({
            method: 'get',
            uri: `userme/me`,
            success: (response) => {
                if (response.result) {
                    this.setState({
                        currentUser: response.result,
                    });
                } else {
                    alert('Failed to get user: ' + response.msg);
                }
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    getLocationTypes() {
        api.fetchAPI({
            method: 'get',
            uri: `location_type/`,
            success: (response) => {
                const filterLocationTypeIds = [];
                response.result.map(locationType => filterLocationTypeIds.push(locationType.id))
                this.setState({
                    locationTypes: response.result,
                    filterLocationTypeIds,
                });
            },
            error: (error) => {
              console.error(error);
              this.setState({ isLoading: false });
            }
        });
    }
    getNearbyLocations() {
        // this.setState({
        //     isLoading: true,
        //     nearbyLocations: [],
        //     nearbyLocationSummary: [],
        // });
        const { currentLocation, scanningRadius, searchBrandName } = this.state;

        let uri = `location/nearby`;
        if (currentLocation.latitude && currentLocation.longitude) {
            uri = `${uri}/?latitude=${currentLocation.latitude}&longitude=${currentLocation.longitude}&radius=${scanningRadius}&get_summary=1&summary_by=brand`;
        }
        if (searchBrandName) {
            uri += `&brand_name=${searchBrandName}`;
        }

        api.fetchAPI({
            method: 'get',
            uri,
            success: (response) => {
                this.setState({
                    nearbyLocations: response.nearby_locations,
                    nearbyLocationSummary: response.nearby_location_summary,
                    isLoading: false,
                });
            },
            error: (error) => {
              console.error(error);
              this.setState({ isLoading: false });
            }
        });
    }
    getPlanningLocations() {
        const siteFilterString = '(col:is_active,opr:eq,value:1)';
        api.fetchAPI({
            method: 'get',
            uri: `planning_point/?q=(filters:!(${siteFilterString}))`,
            success: (response) => {
                this.setState({
                    planningPoints: response.result,
                });
            },
            error: (error) => {
              console.error(error);
              this.setState({ isLoading: false }); 
            }
        });
    }
    getDistrictByCity() {
        const { city } = this.state;
        // district/?q=(filters:!((col:city,opr:rel_o_m,value:${city.id})))
        api.fetchAPI({
            method: 'get',
            uri: `district/`,
            success: (response) => {
                this.setState({
                    districts: response.result,
                });
            },
            error: (error) => {
              console.error(error);
              this.setState({ isLoading: false });
            }
        });
    }
    toogleLocationTypeFilter(locationType) {
        let { filterLocationTypeIds } = this.state;
        if (filterLocationTypeIds.includes(locationType.id)) {
            filterLocationTypeIds = filterLocationTypeIds.filter(item => item !== locationType.id);
        } else {
            filterLocationTypeIds.push(locationType.id);
        }
        this.setState({ filterLocationTypeIds });
    }
    onMapItemHover(hoveredObject, x, y) {
        this.setState({
            hoveredObject,
            pointerX: x,
            pointerY: y,
        });
    }
    onMapItemClick(hoveredObject, x, y) {
        this.setState({
            hoveredObject,
            clickedPointerX: x,
            clickedPointerY: y,
            isAddingNewPlanningPoint: false,
        });
    }
    onPlanningPointClick(item) {
        this.setState({
            planningPoint: item.object,
        });
    }
    selectNewLocation(info) {
        const { planningPoint, currentUser, planningPoints } = this.state;
        planningPoint.latitude = info.coordinate[0];
        planningPoint.longitude = info.coordinate[1];
        planningPoint.changed_by = currentUser.id;
        planningPoint.created_by = currentUser.id;
        planningPoint.brand = {
            id: currentUser.user_brand.brand_id,
            name: currentUser.user_brand.brand_name,
        };
        planningPoints.push(planningPoint);
        this.setState({
            isAddingNewPlanningPoint: true,
            planningPoint,
        });
    }
    planningPointEditAttribute(attributeName, value) {
        const { planningPoint } = this.state;
        planningPoint[attributeName] = value;
        this.setState({ planningPoint });
    }
    setScanningRadius(radius) {
        this.setState({
            scanningRadius: radius,
        });
    }
    onBrandSelected(brandId) {
        this.setState({
            selectedBrandId: brandId,
        });
    }
    goToInitialLocation() {
        const { latitude, longitude } = this.initialViewState;
        this.setState({
            currentLocation: {
                latitude: latitude,
                longitude: longitude,
            },
            viewState: this.initialViewState
        }, this.getNearbyLocations);
    }
    addNewLocation() {
        const { planningPoints, planningPoint } = this.state;
        api.fetchAPI({
            method: planningPoint.id ? 'put' : 'post',
            uri: planningPoint.id ? `planning_point/${planningPoint.id}` : `planning_point/`,
            body: planningPoint,
            success: (response) => {
                if (response.result) {
                    this.setState({ planningPoints: [...planningPoints, planningPoint], isAddingNewPlanningPoint: false, planningPoint: {} });
                } else {
                    alert(response.msg);
                }
            },
            error: (error) => {
              console.error(error);
              this.setState({ isLoading: false });
            }
        });
    }
    deactivatePlanningPoint() {
        const { planningPoints, planningPoint } = this.state;
        planningPoint.is_active = 0;
        api.fetchAPI({
            method: 'put',
            uri: `planning_point/${planningPoint.id}`,
            body: planningPoint,
            success: (response) => {
                if (response.result) {
                    this.setState({ planningPoints: planningPoints.filter(point => point.id !== planningPoint.id), isAddingNewPlanningPoint: false, planningPoint: {} });
                } else {
                    alert(response.msg);
                }
            },
            error: (error) => {
              console.error(error);
              this.setState({ isLoading: false });
            }
        });
    }
    onLocationMapItemClick(object) {
        const confirmation = window.confirm(`Bạn sẽ chọn ${object.name} để so sánh?`);
        const { onItemPicked } = this.props;
        if (confirmation) {
            if (onItemPicked) {
                onItemPicked(object);
            }
        }
    }
    onMapClick(mapInfo) {
        let site = {}
        if (mapInfo.object) {
            site = mapInfo.object;
        } else {
            if (mapInfo.coordinate) {
                site = {
                    latitude: mapInfo.coordinate[1],
                    longitude: mapInfo.coordinate[0],
                };
            }
        }
        const currentLocation = {
            latitude: site.latitude,
            longitude: site.longitude
        };
        this.setState({
            currentLocation,
            viewState: {
                ...this.state.viewState,
                latitude: site.latitude,
                longitude: site.longitude
            }
        }, this.getNearbyLocations);
    }
    onEnterPressed(e) {
        if (e.key === 'Enter') {
            this.getNearbyLocations();
        }
    }
    _renderTooltip() {
        let { hoveredObject, pointerX, pointerY, isMapObjectClicked, clickedPointerX, clickedPointerY } = this.state || {};
        
        return hoveredObject && (
            <div
                className="map_hover_tooltip" 
                style={{
                    position: 'absolute',
                    zIndex: 1,
                    left: isMapObjectClicked ? clickedPointerX : pointerX,
                    top: isMapObjectClicked ? clickedPointerY : pointerY,
                }}
            >
                {(hoveredObject.brand || hoveredObject.brand_name) &&
                    <span className="map_hover_tooltip_text brand">{hoveredObject.brand_name || hoveredObject.brand.name}<br /></span>
                }
                {hoveredObject.site_dev_status && hoveredObject.site_dev_status !== 'complete' &&
                    <span className="map_hover_tooltip_text">Status: {hoveredObject.site_dev_status}<br /></span>
                }
                {(hoveredObject.properties) &&
                    <span className="map_hover_tooltip_text brand">{hoveredObject.properties.name || ''}<br /></span>
                }
                {(hoveredObject.address) &&
                    <span className="map_hover_tooltip_text brand">{hoveredObject.address || ''}<br /></span>
                }
                <span className="map_hover_tooltip_text">{ hoveredObject.name || hoveredObject.address || '' }</span><br />
                {(hoveredObject.location_type || hoveredObject.location_type_name) &&
                    <span className="map_hover_tooltip_text">Type: {hoveredObject.location_type_name || hoveredObject.location_type.name}<br /></span>
                }
                {hoveredObject.description &&
                    <span className="map_hover_tooltip_text">{hoveredObject.description}<br /></span>
                }
                {hoveredObject.distance_in_km &&
                    <span className="map_hover_tooltip_text">Distance: {numeral(hoveredObject.distance_in_km * 1000).format('0,00')} m</span>
                }
            </div>
        );
    }
    generateGoogleMapsMarkers() {
        const {
            nearbyLocations, isMapObjectClicked, currentLocation,
            showLocations, filterLocationTypeIds,
            currentUser,
        } = this.state;

        let markerList = [];
        
        // Add current location
        markerList.push(
            { latitude: currentLocation.latitude, longitude: currentLocation.longitude }
        );

        // Add nearby location
        if (nearbyLocations && showLocations) {
            let filteredLocations = nearbyLocations;
            if (filterLocationTypeIds && filterLocationTypeIds.length > 0) {
                filteredLocations = nearbyLocations.filter(location => filterLocationTypeIds.includes(location.location_type_id));
            }
            const nearbyLocationDataToShow = filteredLocations.map(nearbyLocation => {
                return {
                    name: nearbyLocation.name,
                    title: nearbyLocation.name,
                    longitude: nearbyLocation.longitude,
                    latitude: nearbyLocation.latitude,
                    ...nearbyLocation,
                }
            });
            const currentUserBrandLocations = nearbyLocations.filter(location => location.brand_id === currentUser.user_brand.brand_id).map(nearbyLocation => {
                return {
                    name: nearbyLocation.name,
                    title: nearbyLocation.name,
                    longitude: nearbyLocation.longitude,
                    latitude: nearbyLocation.latitude,
                    ...nearbyLocation,
                }
            });
            markerList = markerList.concat(nearbyLocationDataToShow);
            markerList = markerList.concat(currentUserBrandLocations);
        }

        return markerList;
    }
    renderMapLayers() {
        const {
            nearbyLocations, isMapObjectClicked, currentLocation,
            showLocations, filterLocationTypeIds,
            currentUser,
        } = this.state;

        const mapLayers = [];
        // Draw nearby location
        if (nearbyLocations && showLocations) {
            let filteredLocations = nearbyLocations;
            if (filterLocationTypeIds && filterLocationTypeIds.length > 0) {
                filteredLocations = nearbyLocations.filter(location => filterLocationTypeIds.includes(location.location_type_id));
            }
            const nearbyLocationDataToShow = filteredLocations.map(nearbyLocation => {
                return {
                    name: nearbyLocation.name,
                    address: nearbyLocation.name,
                    coordinates: [nearbyLocation.longitude, nearbyLocation.latitude],
                    ...nearbyLocation,
                }
            });
            const currentUserBrandLocations = nearbyLocations.filter(location => location.brand_id === currentUser.user_brand.brand_id).map(nearbyLocation => {
                return {
                    name: nearbyLocation.name,
                    address: nearbyLocation.name,
                    coordinates: [nearbyLocation.longitude, nearbyLocation.latitude],
                    ...nearbyLocation,
                }
            });
            mapLayers.push(
                // Layer for current location
                new ScatterplotLayer({
                    id: 'current-location-layer',
                    data: [currentLocation],
                    pickable: true,
                    opacity: 1,
                    stroked: true,
                    filled: true,
                    radiusScale: 1,
                    radiusMinPixels: 10,
                    radiusMaxPixels: 20,
                    lineWidthMinPixels: 4,
                    getPosition: d => [d.longitude, d.latitude],
                    getRadius: 10,
                    getFillColor: [41, 190, 255, 255],
                    getLineColor: [255, 104, 0],
                }),

                // Layer for near by location
                new ScatterplotLayer({
                    id: 'nearby-location-layer',
                    data: nearbyLocationDataToShow,
                    pickable: true,
                    opacity: 1,
                    stroked: false,
                    filled: true,
                    radiusScale: 1,
                    radiusMinPixels: 10,
                    radiusMaxPixels: 20,
                    getPosition: d => d.coordinates,
                    getRadius: d => d.radius_scale,
                    getFillColor: d => d.rgba_color_normalized,
                    onHover: info => !isMapObjectClicked && this.onMapItemHover(info.object, info.x, info.y),
                    onClick: info => this.onLocationMapItemClick(info),
                }),
                new ScatterplotLayer({
                    id: 'selected-brand-location-layer',
                    data: currentUserBrandLocations,
                    pickable: true,
                    opacity: 0.6,
                    stroked: true,
                    filled: true,
                    radiusScale: 4,
                    radiusMinPixels: 10,
                    radiusMaxPixels: 20,
                    lineWidthMinPixels: 6,
                    getPosition: d => d.coordinates,
                    getRadius: d => d.radius_scale,
                    getFillColor: d => [226, 255, 14],
                    getLineColor: d => [18, 217, 252],
                    onHover: info => !isMapObjectClicked && this.onMapItemHover(info.object, info.x, info.y),
                    onClick: info => this.onLocationMapItemClick(info.object),
                }),
                // Layer for brand logo
                new IconLayer({
                    id: 'nearby-location-logo-layer',
                    data: nearbyLocationDataToShow.filter(nearbyLocation => nearbyLocation.brand_logo_image && nearbyLocation.is_competitor).map(nearbyLocation => {
                        if (nearbyLocation.brand_logo_image) {
                            return {
                                name: nearbyLocation.name,
                                address: nearbyLocation.name,
                                coordinates: [nearbyLocation.longitude, nearbyLocation.latitude],
                                ...nearbyLocation,
                            };
                        }
                    }),
                    getIcon: d => ({
                      url: d.brand_logo_image || '',
                      width: 32,
                      height: 32,
                      id: d.id,
                    }),
                    getSize: 32,
                    sizeScale: 1,
                    getPosition: d => d.coordinates,
                    pickable: true,
                    onHover: info => !isMapObjectClicked && this.onMapItemHover(info.object, info.x, info.y),
                    onClick: info => this.onLocationMapItemClick(info.object),
                }),
                // Text Layer for selected brand site
                new TextLayer({
                    id: 'selected-brand-location-text-layer',
                    data: currentUserBrandLocations,
                    getText: d => d.site_dev_status,
                    getSize: 24,
                    getTextAnchor: 'middle',
                    getAlignmentBaseline: 'top',
                    getPixelOffset: [0, 20],
                    getColor: [255, 255, 255, 255],
                    sizeScale: 1,
                    fontFamily: 'Arial',
                    getPosition: d => d.coordinates,
                    pickable: true,
                    onHover: info => !isMapObjectClicked && this.onMapItemHover(info.object, info.x, info.y),
                    onClick: info => this.onMapItemClick(info.object),
                }),
            );
        }
        return mapLayers;
    }

    _onViewStateChange({viewState}) {
        //this.setState({viewState});
    }

    render() {
        const {
            currentUser,
            currentLocation,
            nearbyLocationSummary,
            nearbyLocations,
            scanningRadius,
            isLoading,
            selectedBrandId,
            searchBrandName,
            showOverlayMenu,
            viewState,
            mapMode,
            mapTheme,
        } = this.state;

        const { pickToSelectLocation } = this.props;

        const mapLayers = this.renderMapLayers();

        return (
            <Container>
                <div className="map_screen__container">
                    {mapMode === 'mapbox' &&
                        <DeckGL
                            viewState={viewState}
                            onViewStateChange={(state)=>{
                                this.setState({viewState: state.viewState})
                            }}
                            layers={mapLayers}
                            controller={true}
                            onClick={info => pickToSelectLocation ? () => {return;} : this.onMapClick(info)}
                        >
                            <MapView
                                id="location_map"
                                controller
                            >
                                <StaticMap
                                    mapStyle={`mapbox://styles/mapbox/${mapTheme}`}
                                    mapboxApiAccessToken={Constant.MAPBOX_API_ACCESS_TOKEN}
                                />
                            </MapView>
                            { this._renderTooltip() }
                        </DeckGL>
                    }
                    {mapMode === 'google_maps' &&
                        <GoogleMap
                            initialCenter={{
                                lat: viewState.latitude,
                                lng: viewState.longitude,
                            }}
                            zoom={viewState.zoom}
                            markerList={this.generateGoogleMapsMarkers()}
                        />
                    }
                    {showOverlayMenu ?
                        <div className="map-components_overlay-main">
                            <Row>
                                <Col xs={12}>
                                    <div className="map-components_overlay-main-close__container">
                                        <span
                                            className="map-components_overlay-main-close"
                                            color="secondary"
                                            onClick={() => this.setState({ showOverlayMenu: false })}
                                        >
                                            x
                                        </span>
                                    </div>
                                    <FormGroup>
                                        <Button
                                            outline
                                            size="sm"
                                            color="primary"
                                            onClick={() => this.setState({ mapMode: 'mapbox', mapTheme: 'light-v10' })}
                                        >
                                            Light
                                        </Button>{' '}
                                        <Button
                                            outline
                                            size="sm"
                                            color="primary"
                                            onClick={() => this.setState({ mapMode: 'mapbox', mapTheme: 'streets-v11' })}
                                        >
                                            Street
                                        </Button>{' '}
                                        <Button
                                            outline
                                            size="sm"
                                            color="primary"
                                            onClick={() => this.setState({ mapMode: 'mapbox', mapTheme: 'satellite-v9' })}
                                        >
                                            Satellite
                                        </Button>{' '}
                                        <Button
                                            outline
                                            size="sm"
                                            color="primary"
                                            onClick={() => this.setState({ mapMode: 'google_maps' })}
                                        >
                                            Google Maps
                                        </Button>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>Bán kính scan (km)</Label>
                                        <Input
                                            type="text"
                                            value={scanningRadius}
                                            onChange={(e) => this.setScanningRadius(e.target.value)}
                                            onKeyDown={(e) => this.onEnterPressed(e)}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>Tìm theo thương hiệu</Label>
                                        <Input
                                            type="text"
                                            value={searchBrandName}
                                            onChange={(e) => this.setState({ searchBrandName: e.target.value })}
                                            onKeyDown={(e) => this.onEnterPressed(e)}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Button
                                            size="sm"
                                            color={isLoading ? 'secondary' : 'primary'}
                                            disabled={isLoading}
                                            onClick={() => this.getNearbyLocations()}
                                        >
                                            {isLoading ? 'Loading...' : 'Lấy dữ liệu'}
                                        </Button>
                                    </FormGroup>
                                </Col>
                                <Col xs={12}>
                                    {nearbyLocationSummary &&
                                        <div>
                                            <p>Xung quanh đây có</p>
                                            {nearbyLocationSummary.map(summaryItem =>
                                                <BrandItem
                                                    key={summaryItem.brand_id}
                                                    brand={summaryItem}
                                                    currentUser={currentUser}
                                                    nearbyLocations={nearbyLocations}
                                                />
                                            )}
                                        </div>
                                    }
                                </Col>
                            </Row>
                        </div>
                        :
                        <div
                            className="map-components_overlay-show_menu_button"
                        >
                            <Button
                                size="sm"
                                color="primary"
                                onClick={() => this.setState({ showOverlayMenu: true })}
                            >
                                Menu
                            </Button>{' '}
                            <Button
                                size="sm"
                                color="primary"
                                onClick={() => this.goToInitialLocation()}
                            >
                                Quay về vị trí ban đầu
                            </Button>
                        </div>
                    }
                </div>
            </Container>
        )
    }
}

export default MapComponent;